<template>
  <div class="file-preview" :style="{'z-index':zIndex}" @contextmenu.prevent="">
    <div class="file-header">
      <div v-if="previewAttr.fileCount>0" class="file-counter">{{ previewAttr.index+1 }} / {{ previewAttr.fileCount }}</div>
      <div v-if="file.name" class="file-name">{{ file.name }}</div>
      <div v-else class="file-name">{{ file.title }}.{{ file.suffix }}</div>
      <div class="redo-btn icon-huifu" title="重新转码" @click="handleRedo" />
      <i class="icon-close-normal file-nav close" @click="close" />
    </div>
    <div class="file-wrapper">
      <div class="file-item">
        <!-- 图片方式预览pdf -->
        <preview-pdf-image v-if="localPdfImages.length>0 && isLoad === 1" ref="pdf" :data="localPdfImages" :toolbar-type="1" :external-zoom="previewAttr.zoom" @changeIndex="changeIndex" @zoomChange="handleZoomChange" />
        <div v-if="isLoad === 0" v-loading="true" element-loading-background="transparent" element-loading-text="文件正在处理中" class="loading-wrap" />
        <div v-if="isLoad === -1" class="error-wrap">
          <div class="error-content">
            <i class="el-icon-warning"></i>
            <p>加载失败，请检查网络连接</p>
            <el-button type="primary" size="small" @click="fetchPdfData">重新加载</el-button>
          </div>
        </div>
        <div v-if="showcrop" class="cropper-wrap has-navigation">
          <Cropper :id="file.id" ref="cropper" :data="cropData" @cancle="onCancle" @success="onCropSucc" />
        </div>
        <image-navigation v-if="localPdfImages.length>0 && isLoad === 1" :id="file.id" :node-id="file.nodeId" :res-node="resNode" :content-id="contentId" :data="localPdfImages" :index="pdfIndex" @goPage="goPage" @crop="onCrop" @setCoverSuccess="setCoverSuccess" />
      </div>
    </div>
  </div>
</template>

<script>
import PreviewPdfImage from './PreviewPdfImage'
import ImageNavigation from './ImageNavigation'
import Cropper from './Cropper'
import { setCoverPicture, redoOffice } from '@/api/common'

export default {
  name: 'FilePreview',
  components: {
    PreviewPdfImage,
    ImageNavigation,
    Cropper
  },
  props: {
    /**
     * PDF文件标题
     * @required
     * @type {String}
     */
    title: {
      type: String,
      required: true
    },
    /**
     * 应用ID
     * @required
     * @type {Number}
     */
    appId: {
      type: Number,
      required: true
    },
    /**
     * 视频ID
     * @required
     * @type {Number}
     */
    vid: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      previewAttr: {
        index: 0,
        zoom: 100,
        fileCount: 0
      },
      showcrop: false, // 显示裁剪
      cropData: {},
      file: {},
      fileType: 'pdf',
      localPdfImages: [], // 本地图片数组，避免直接修改props
      isLoad: 0, // 加载状态：0-加载中，1-加载成功，-1-加载失败
      pdfIndex: 0,
      zIndex: 2000,
      currentNodeId: 133, // 当前节点id
      currentResId: 69474, // 当前资源id
      documentTitle: '加载中...', // 文档标题
    }
  },
  mounted() {
    this.currentNodeId = this.appId
    this.currentResId = this.vid
    
    this.file = {
      id: this.vid,
      name: `${this.title}.pdf`,
      title: this.title,
      suffix: 'pdf',
      url: '',
      nodeId: this.appId
    }
    
    this.documentTitle = this.title
    
    this.zIndex = 2000 + Math.floor(Math.random() * 1000)
    
    // 获取PDF数据
    this.fetchPdfData()
    
    this.$nextTick(() => {
      const body = document.querySelector('body')
      if (body.append) {
        body.append(this.$el)
      } else {
        body.appendChild(this.$el)
      }
    })
  },
  methods: {
    /**
     * 获取PDF数据
     */
    async fetchPdfData() {
      try {
        this.isLoad = 0 // 开始加载
        
        const requestBody = {
          appId: this.appId,
          vid: this.vid
        }
        
        const response = await fetch('http://dms.dev.multimediapress.cn/dms/api/v2/filePreview', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        })
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        
        const result = await response.json()
        
        if (result.data && Array.isArray(result.data)) {
          // 新的数据结构：result.data 是数组，result.title 是文档标题
          this.localPdfImages = result.data
          this.previewAttr.fileCount = this.localPdfImages.length
          
          // 使用API返回的title，如果没有则使用外部传入的title
          if (result.title) {
            this.file.title = result.title
            this.file.name = result.title
          } else {
            this.file.title = this.title
            this.file.name = `${this.title}.pdf`
          }
          
          // 设置第一张图片为默认URL
          if (this.localPdfImages.length > 0) {
            this.file.url = this.localPdfImages[0].url
          }
          
          this.isLoad = 1 // 加载成功
        } else {
          throw new Error('获取PDF数据失败：数据格式不正确')
        }
      } catch (error) {
        console.error('获取PDF数据失败:', error)
        this.isLoad = -1 // 加载失败
        this.$message.error('获取PDF数据失败: ' + error.message)
      }
    },
    handleRedo() {
      redoOffice(this.currentNodeId, this.file.id).then(response => {
        const { code, msg } = response
        if (code === 200) {
          this.$message.success('重新转码成功')
          if (this.$parent.getContentChildList) {
            this.$parent.getContentChildList()
          }
        } else {
          this.$message.error(msg)
        }
      })
    },
    onCancle() {
      // 取消裁剪
      this.showcrop = false
    },
    onCropSucc(data) {
      // 裁剪成功过
      this.showcrop = false
      const index = this.localPdfImages.findIndex(val => {
        return val.id === data.id
      })
      if (index === -1) {
        this.localPdfImages.push(data)
      } else {
        this.localPdfImages.splice(index, index + 1, data)
      }
    },
    onCrop(data) {
      // 图片裁剪
      this.showcrop = true
      this.cropData = data
    },
    changeIndex(index) {
      this.pdfIndex = index
      // 发射页面变化事件
      this.$emit('page-change', index)
    },
    goPage(index, data) {
      this.$refs.pdf.goPage(index)
      if (this.showcrop) {
        this.cropData = data
      }
    },
    close() {
      this.$emit('close')
    },
    handleSetCover() {
      // 设为封面图
      const params = {
        nodeId: this.file.nodeId,
        contentId: this.file.id,
        url: this.file.url,
        type: 0
      }
      setCoverPicture(params).then(response => {
        const { code, msg } = response
        if (code === 200) {
          this.$message.success('设为封面图成功！')
        } else {
          this.$message.error(msg)
        }
      })
    },
    handleSetResCover() {
      // 设为资源封面图
      const params = {
        nodeId: this.currentNodeId,
        contentId: this.currentResId,
        url: this.file.url,
        type: 0
      }
      if (this.resNode) {
        params.nodeId = this.resNode
      }
      if (this.contentId) {
        params.contentId = this.contentId
      }
      setCoverPicture(params).then(response => {
        const { code, msg } = response
        if (code === 200) {
          this.setCoverSuccess()
          this.$message.success('设为资源封面图成功！')
        } else {
          this.$message.error(msg)
        }
      })
    },
    setCoverSuccess() {
      this.$emit('setCoverSuccess')
    },
    /**
     * 暴露的方法：上一页
     * @public
     */
    prevPage() {
      if (this.$refs.pdf && this.localPdfImages.length > 0 && this.isLoad === 1) {
        this.$refs.pdf.handlePrev()
        // 发射上一页事件
        this.$emit('prev-page', this.$refs.pdf.index)
      }
    },
    /**
     * 暴露的方法：下一页
     * @public
     */
    nextPage() {
      if (this.$refs.pdf && this.localPdfImages.length > 0 && this.isLoad === 1) {
        this.$refs.pdf.handleNext()
        // 发射下一页事件
        this.$emit('next-page', this.$refs.pdf.index)
      }
    },
    /**
     * 暴露的方法：跳转到指定页
     * @public
     * @param {Number} index - 页码（从0开始）
     */
    goToPage(index) {
      if (this.$refs.pdf && this.localPdfImages.length > 0 && this.isLoad === 1) {
        if (index >= 0 && index < this.localPdfImages.length) {
          this.$refs.pdf.goPage(index)
          // 发射页面跳转事件
          this.$emit('page-change', index)
        }
      }
    },
    /**
     * 暴露的方法：获取当前页码
     * @public
     * @returns {Number} 当前页码（从0开始）
     */
    getCurrentPage() {
      if (this.$refs.pdf && this.localPdfImages.length > 0 && this.isLoad === 1) {
        return this.$refs.pdf.index
      }
      return 0
    },
    /**
     * 暴露的方法：获取总页数
     * @public
     * @returns {Number} 总页数
     */
    getTotalPages() {
      return this.localPdfImages.length
    }
  }
}
</script>

<style scoped>
.redo-btn {
  margin-left: 20px;
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: 70px;
  font-size: 24px;
}
.redo-btn.x-btn {
  font-size: 14px;
}

.viewer-wrapper {
  width: 100%;
  height: 100%;
}
.viewer-wrapper /deep/ .viewer-backdrop {
  background-color: transparent;
}

.viewer {
  display: none;
}

.cropper-wrap {
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.cropper-wrap.has-navigation {
  right: 220px;
}

.file-preview {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 200;
  background: rgba(0, 0, 0, 0.7);
  color: #e6e6e6;
}

.file-header {
  height: 50px;
  line-height: 50px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1;
  padding-right: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-counter {
  color: #9D9D9D;
  display: inline-block;
  padding-left: 20px;
  vertical-align: middle;
}

.file-name {
  display: inline-block;
  padding-left: 20px;
  vertical-align: middle;
  max-width: 500px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-header i {
  font-size: 24px;
  line-height: 50px;
  vertical-align: middle;
}

.file-header .close {
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  text-align: center;
  cursor: pointer;
  color: #fff;
  line-height: 50px;
}

.file-header .close:hover {
  background: #000;
}

.file-header .download {
  position: absolute;
  top: 0;
  right: 60px;
  cursor: pointer;
  width: 100px;
  text-align: center;
  color: #fff;
  padding: 0 20px;
  transition: background 218ms ease;
}

.file-header .download:hover {
  background: #000;
}

.file-header .download i {
  margin-right: 5px;
}

.file-wrapper {
  position: relative;
  padding-top: 50px;
  width: 100%;
  height: 100%;
}

.file-item {
  text-align: center;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
}

.file-item img {
  transition: width, height, transform 0.15s;
  background: #fff;
}

.loading-wrap {
  width: 100%;
  height: 100%;
}

.error-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.8);
}

.error-content {
  text-align: center;
  color: #fff;
}

.error-content i {
  font-size: 48px;
  color: #f56c6c;
  margin-bottom: 20px;
}

.error-content p {
  margin: 20px 0;
  font-size: 16px;
}

.player-box {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.player-box /deep/ .prism-cue * {
  background-color: transparent !important;
}

.preview-item {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 100%;
  max-height: 100%;
}
</style>
